export default "__VITE_ASSET__DBFhav7A__"